import Model, { attr, belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { DayjsTransformReturn } from 'frontend-utils/transforms/dayjs';
import type { Period } from 'lumen/models';
import type { HoteldateTransformReturn } from 'lumen/transforms/hoteldate';
import type {
  RESTRICTION_MODEL_CONTEXTS,
  RESTRICTION_TYPES,
} from 'lumen/utils/constants/channel-pricing-constants';
import type { AbstractActionValue } from 'lumen/utils/constants/restriction-actions';
import { ABSTRACT_ACTIONS } from 'lumen/utils/constants/restriction-actions';

type restrictionValue = {
  type: (typeof RESTRICTION_TYPES)[keyof typeof RESTRICTION_TYPES];
  value: number;
};

export default class RestrictionAction extends Model {
  [Type] = 'restriction-action' as const;

  @belongsTo('period', { async: false, inverse: 'restrictionActions' })
  declare period: Period;

  @attr('string') declare action: AbstractActionValue;
  @attr('number') declare actionedUserId: number;
  // Note: autopilot hasn't been relevant for restrictions right now. Made this a string for now. To be checked further later
  @attr('string') declare autopilotScheduleTimestamp: string | null;
  @attr('string') declare bulkPushId: string | null;
  @attr('string') declare channelId: string | null;
  @attr('string')
  declare context: (typeof RESTRICTION_MODEL_CONTEXTS)[keyof typeof RESTRICTION_MODEL_CONTEXTS];
  @attr('dayjs') declare createdAt: DayjsTransformReturn;
  @attr('json') declare currentValues: restrictionValue[];
  @attr('hoteldate') declare fromDate: NonNullable<HoteldateTransformReturn>;
  @attr('string') declare otaId: string | null;
  @attr('string') declare pmsStateText: string;
  @attr('string') declare rateId: string | null;
  @attr('string') declare roomId: string | null;
  @attr('string') declare source: string;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get hasException() {
    return this.action === ABSTRACT_ACTIONS.EXCEPTION;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isAccepted() {
    return this.action === ABSTRACT_ACTIONS.ACCEPTED;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isPushing() {
    return this.action === ABSTRACT_ACTIONS.PUSHING;
  }
}
